<template lang="pug">
a.btn.btn-outline-primary.btn-lg.btn-block.py-4(:class="{ active: isSelected }") {{ title }}
</template>

<script>
export default {
  name: "SizeItem",
  props: {
    title: String,
    isSelected: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.btn:hover,
.btn.active {
  color: #faad00 !important;
  border-color: #faad00 !important;
  background-color: #ffecc7 !important;
}

.btn-outline-primary {
  color: #082b6b;
  border-color: #082b6b;
}

.btn {
  background-color: #e6ecf4;
}
</style>
